import { Reducer } from 'redux'

import {
  BuyersAction,
  BuyersActionTypes,
  BuyersData,
  initialBuyersState,
} from './types'

export const reducer: Reducer<BuyersData, BuyersAction> = (
  state = initialBuyersState,
  action
) => {
  switch (action.type) {
    case BuyersActionTypes.SET_BUYERS: {
      return {
        ...state,
        buyers: action.payload.buyers,
      }
    }
    case BuyersActionTypes.SET_BUYER_CONTRACTS_DATA: {
      return {
        ...state,
        buyerContracts: action.payload,
      }
    }
    case BuyersActionTypes.SET_JOURNEY_DATA: {
      return {
        ...state,
        buyerJourney: action.payload,
      }
    }
    case BuyersActionTypes.CLEAR_BUYERS: {
      return {
        ...state,
        buyers: [],
      }
    }
    default:
      return state
  }
}
